import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import IconButton from 'LuxKit/Button/IconButton'
import LineBracketsCurlyIcon from 'LuxKit/Icons/line/LineBracketsCurlyIcon'
import { openLabPayloadInNewTab, hasLabPayload } from './ExperimentPanelHelpers'

interface LabPayloadLinkIconProps {
  flagKey: string
  payload: unknown | undefined
}

function LabPayloadLinkIcon({ flagKey, payload }: LabPayloadLinkIconProps) {
  const intl = useIntl()
  const viewPayloadLabel = intl.formatMessage({
    id: 'temp_lab_payload_link_icon_label',
    defaultMessage: 'View payload',
    description: 'Accessible label for the icon button that opens a Lab flag JSON payload in a new browser tab',
  })

  const handleOpenPayload = useCallback(() => {
    openLabPayloadInNewTab(flagKey, payload)
  }, [flagKey, payload])

  if (!hasLabPayload(payload)) {
    return null
  }

  return (
    <IconButton
      kind="tertiary"
      size="small"
      onClick={handleOpenPayload}
      aria-label={viewPayloadLabel}
    >
      <LineBracketsCurlyIcon />
    </IconButton>
  )
}

export default LabPayloadLinkIcon
